import { c as _c } from "react/compiler-runtime";
import type { VerifiedPrefillOutput, VerifiedPrefillOutputKind } from '@onefootprint/request-types/dashboard';
import { Divider } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import OutputMappings, { type OutputMapping } from '../output-mappings';

/** Tolerates a missing field: a backend that predates prefill outputs omits it entirely. */
export const toOutputMappings = (outputs: VerifiedPrefillOutput[] | undefined): OutputMapping[] => (outputs ?? []).map(({
  kind,
  onboardingDataKey
}) => ({
  fieldKey: kind,
  onboardingDataKey
}));
export const fromOutputMappings = (outputs: OutputMapping[]): VerifiedPrefillOutput[] => outputs.map(({
  fieldKey,
  onboardingDataKey
}) => ({
  kind: fieldKey as VerifiedPrefillOutputKind,
  onboardingDataKey
}));

/** Shared by the Verified prefill node and the identity data node that runs prefill inline. */
const VerifiedPrefillOutputs = t0 => {
  const $ = _c(16);
  const {
    canEdit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "verifiedPrefill.outputs"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "outputs"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const outputs = useWatch(t2);
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = [{
      value: "raw_response",
      label: t3
    }];
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const kinds = t4;
  if (!canEdit && !outputs?.length) {
    return null;
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp2);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp3);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== canEdit || $[12] !== kinds || $[13] !== t6 || $[14] !== t7) {
    t8 = <>{t5}<OutputMappings canEdit={canEdit} subtitle={t6} options={kinds} outputLabel={t7} /></>;
    $[11] = canEdit;
    $[12] = kinds;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default VerifiedPrefillOutputs;
function _temp($) {
  return $.kinds.rawResponse;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.outputLabel;
}